import * as z from "zod/v4";

export const addErrorMessage = {
  name: "addErrorMessage" as const,
  input: z.object({
    type: z.enum(["terminal", "retryable"]),
    rawErrorMessage: z.string(),
    prettyErrorMessage: z.string(),
  }),
  output: z.object({ success: z.boolean() }),
};
